import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCapIcon, MessageCircleIcon, VideoIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-brand-bg pt-8 md:pt-12 pb-8 md:pb-10 relative overflow-hidden" data-id="element-244">
      <div className="absolute bottom-0 left-0 right-0 h-[70%] bg-gradient-to-t from-[#22c55e]/10 via-[#22c55e]/5 to-transparent pointer-events-none" data-id="element-245" />
      <div className="absolute -top-[10%] left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-[#22c55e]/[0.14] rounded-full blur-[120px] pointer-events-none" data-id="element-246" />

      {/* Title + Subtitle */}
      <div className="max-w-5xl mx-auto text-center relative z-10 px-6" data-id="element-247">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-248">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight max-w-5xl mx-auto text-center" data-id="element-249">
            Genera tus primeros{' '}
            <span className="text-[#1fa855]" data-id="element-250">$1,000 dólares mensuales</span>{' '}
            vendiendo tu <span className="text-[#1fa855]" data-id="element-251">ebook digital</span>{' '}
            en solo <span className="text-[#1fa855]" data-id="element-252">7 días</span>
          </h1>
          <div className="flex justify-center mt-4 mb-2" data-id="element-253">
            <div className="w-16 h-1 rounded-full bg-[#1fa855]" data-id="element-254" />
          </div>
        </motion.div>
      </div>

      {/* CTA Title */}
      <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-brand-dark text-center px-6 mt-10 mb-4 leading-tight" data-id="element-255">
        Empezá hoy y construí{' '}
        <span className="text-[#1fa855]" data-id="element-256">una fuente de ingresos propia</span>{' '}
        paso a paso
      </h2>
      <p className="text-base md:text-lg text-gray-600 text-center px-6 mb-8 font-medium" data-id="element-257">
        🔥 +1300 resultados reales de alumnos que están vendiendo sus ebooks
      </p>

      {/* Carousel - full width */}
      <div className="flex gap-4 overflow-x-auto cursor-grab active:cursor-grabbing snap-x snap-mandatory pl-6 pr-6 relative z-10" style={{
      WebkitOverflowScrolling: 'touch',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none'
    }} data-id="element-258">
        {[{
        type: 'video',
        src: 'https://cdn.magicpatterns.com/uploads/fgmiWFwxz9mdRLU5CZhwr7/VIDEODELTAPARACAMPAN%CC%83A.mp4'
      }, {
        type: 'image',
        src: 'https://cdn.magicpatterns.com/uploads/idppeFC4n7nsEuDs5UmUeB/Imagen_28-3-26_a_las_6.52_p._m..jpg'
      }, {
        type: 'image',
        src: 'https://cdn.magicpatterns.com/uploads/6TgDtquuyyH1mGpRCPs5Sw/Imagen_29-3-26_a_las_5.50_p._m..jpg'
      }, {
        type: 'image',
        src: 'https://cdn.magicpatterns.com/uploads/gjPNBPpsxnhmXt7P1dKUsv/Imagen_28-3-26_a_las_6.57_p._m..jpg'
      }].map((item, i) => <div key={i} className="flex-shrink-0 w-[30%] min-w-[260px] rounded-2xl overflow-hidden bg-[#22c55e] shadow-lg snap-start p-3 flex items-center justify-center" data-id="element-259">
            {item.type === 'image' ? <img src={item.src} alt={`Resultado de alumno ${i + 1}`} className="w-full h-auto rounded-xl" draggable={false} data-id="element-260" /> : <video src={item.src} className="w-full h-auto rounded-xl" autoPlay muted loop playsInline data-id="element-261" />}
          </div>)}
      </div>

      {/* ESTO ES PARA VOS SI... */}
      <div className="max-w-3xl mx-auto px-6 mt-14 mb-4" data-id="element-262">
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 text-center mb-10" data-id="element-263">
          ESTO ES PARA VOS SI...
        </h2>
        <div className="space-y-6" data-id="element-264">
          {[{
          text: 'Tenés un ebook o querés crear uno, pero',
          bold: 'no sabés cómo venderlo ni por dónde empezar.'
        }, {
          text: 'Sentís que podrías',
          bold: 'generar ingresos con lo que sabés',
          after: ', pero la parte técnica te frena (tienda, pagos, automatización…).'
        }, {
          text: 'Sos emprendedor/emprendedora y hacés todo sola/o, y',
          bold: 'necesitás una forma simple de vender',
          after: ' sin agregar más tareas a tu rutina.'
        }, {
          text: 'Estás cansada/o de ver cursos que te dan vueltas, y',
          bold: 'querés una guía práctica, clara y directa',
          after: ' que puedas aplicar hoy mismo.'
        }, {
          text: 'Querés lanzar tu tienda digital, automatizar tus ventas y',
          bold: 'vender tu ebook 24/7',
          after: ' sin depender de Instagram o WhatsApp.'
        }].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-265">
              <span className="flex-shrink-0 w-10 h-10 bg-green-500 rounded-full flex items-center justify-center mt-0.5" data-id="element-266">
                <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-267">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-268" />
                </svg>
              </span>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-269">
                {item.text}{' '}
                <strong className="text-gray-900" data-id="element-270">{item.bold}</strong>
                {item.after || ''}
              </p>
            </div>)}
        </div>

        {/* Formula image */}
        <div className="mt-12 -mx-6 flex justify-center" data-id="element-271">
          <img src="https://cdn.magicpatterns.com/uploads/wHpW7BXKLYPuANXycsFkcU/3.png" alt="La fórmula paso a paso para lograr ventas en Shopify y en automático" className="w-full max-w-5xl h-auto" data-id="element-272" />
        </div>

        {/* Por qué deberías tener image */}
        <div className="mt-10 -mx-6 flex justify-center" data-id="element-273">
          <img src="https://cdn.magicpatterns.com/uploads/tasf5bp9kxedW6xTf2KCcy/15.png" alt="¿Por qué deberías tener Vende tu Primer eBook en Shopify?" className="w-full max-w-5xl h-auto" data-id="element-274" />
        </div>

        {/* QUE VAS A LOGRAR */}
        <div className="mt-14 max-w-3xl mx-auto" data-id="element-275">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 text-center mb-8" data-id="element-276">
            QUE VAS A <span className="text-brand-green" data-id="element-277">LOGRAR</span>:
          </h2>
          <div className="space-y-4" data-id="element-278">
            {[{
            text: 'Tener tu',
            bold: 'tienda digital activa y lista para vender',
            after: ' en horas, aunque hoy no sepas nada de Shopify.'
          }, {
            text: 'Subir tu ebook y',
            bold: 'automatizar la entrega al comprador',
            after: ' sin depender de nadie más.'
          }, {
            text: 'Dejar de improvisar y usar una',
            bold: 'estructura probada que vende',
            after: '.'
          }, {
            text: '',
            bold: 'Evitar errores que te hacen perder ventas',
            after: ', como tener una página desordenada o cobrar mal.'
          }, {
            text: 'Lanzar sin miedo ni dudas, con una checklist que',
            bold: 'te guía paso a paso',
            after: '.'
          }, {
            text: '',
            bold: 'Vender tu ebook en piloto automático',
            after: ': la tienda trabaja por vos mientras vos hacés lo que amás.'
          }].map((item, i) => <div key={i} className="flex items-start gap-4 bg-white border border-green-200 rounded-xl px-5 py-5" data-id="element-279">
                <span className="flex-shrink-0 w-10 h-10 bg-green-500 rounded-full flex items-center justify-center mt-0.5" data-id="element-280">
                  <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-281">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-282" />
                  </svg>
                </span>
                <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-283">
                  {item.text}
                  {item.text ? ' ' : ''}
                  <strong className="text-brand-green" data-id="element-284">{item.bold}</strong>
                  {item.after}
                </p>
              </div>)}
          </div>
        </div>
      </div>

      {/* Video results title + video */}
      <div className="max-w-5xl mx-auto text-center relative z-10 px-6" data-id="element-285">
        <motion.div className="mt-10" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.15
      }} data-id="element-286">
          <div className="relative text-center mb-8" data-id="element-287">
            <div className="absolute left-1/2 -translate-x-1/2 top-[-20%] w-[800px] h-[600px] bg-[#22c55e]/[0.14] rounded-full blur-[120px] pointer-events-none" data-id="element-288" />
            <p className="text-3xl md:text-5xl lg:text-6xl font-bold text-brand-dark max-w-4xl mx-auto leading-tight relative z-10" data-id="element-289">
              Transforma tu conocimiento en{' '}
              <span className="text-[#1fa855]" data-id="element-290">ingresos reales</span> y empieza
              a construir un{' '}
              <span className="text-[#1fa855]" data-id="element-291">negocio digital</span> desde
              cero, sin complicaciones.
            </p>
          </div>

          <motion.h2 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 text-center mb-6 leading-tight" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} data-id="element-292">
            Descubrí cuánto facturé en menos de 3 meses{' '}
            <span className="text-[#1fa855]" data-id="element-293">CON 1 SOLO PRODUCTO</span>
          </motion.h2>

          <motion.p className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-6" initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: 0.1
        }} data-id="element-294">
            Te doy el VERDADERO paso a paso para copiar y pegar.
            <br data-id="element-295" />
            En este video te enseño mis resultados ⬇
          </motion.p>

          <motion.div className="w-full max-w-3xl mx-auto mb-12 md:mb-16" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} data-id="element-296">
            <div className="relative w-full rounded-2xl bg-brand-card border border-gray-200 shadow-lg" style={{
            paddingBottom: '65%'
          }} data-id="element-297">
              <iframe src="https://fast.wistia.net/embed/iframe/9dsb5tsk42?seo=true&videoFoam=true" title="Video de presentación" allow="autoplay; fullscreen" allowFullScreen className="absolute top-0 left-0 w-full h-full rounded-2xl" style={{
              border: 'none'
            }} data-id="element-298" />
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* CTA Button and Feature Cards */}
      <div className="max-w-5xl mx-auto text-center relative z-10 px-6" data-id="element-299">
        <motion.div className="mt-10" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.15
      }} data-id="element-300">
          <div className="mt-10 flex flex-col items-center" data-id="element-301">
            <a href="#" onClick={e => {
            e.preventDefault();
            document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="inline-block bg-brand-green hover:bg-brand-green-hover text-white font-bold text-xl px-16 py-5 rounded-full transition-all duration-300 hover:scale-105 shadow-[0_0_40px_rgba(34,197,94,0.3)] hover:shadow-[0_0_60px_rgba(34,197,94,0.4)] cursor-pointer" data-id="element-302">
              🔥 Acceder Ahora
            </a>
            <p className="mt-5 text-gray-600 text-base md:text-lg font-medium" data-id="element-303">
              ⚡ Acceso Inmediato + De 0 a Escalado en Meta
            </p>

            {/* Feature Cards */}
            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5 w-full max-w-5xl" data-id="element-304">
              <div className="bg-brand-card border border-gray-200 rounded-2xl p-6 text-left shadow-sm" data-id="element-305">
                <div className="flex items-start gap-3 mb-3" data-id="element-306">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-307">
                    <GraduationCapIcon className="w-5 h-5 text-brand-green" data-id="element-308" />
                  </div>
                  <div data-id="element-309">
                    <h3 className="text-gray-900 font-bold text-base" data-id="element-310">
                      Alumnos con resultados{' '}
                      <span className="text-brand-green" data-id="element-311">REALES</span>
                    </h3>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-312">
                  Casos comprobados y testimonios verificables.
                </p>
              </div>

              <div className="bg-brand-card border border-gray-200 rounded-2xl p-6 text-left shadow-sm" data-id="element-313">
                <div className="flex items-start gap-3 mb-3" data-id="element-314">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-315">
                    <MessageCircleIcon className="w-5 h-5 text-brand-green" data-id="element-316" />
                  </div>
                  <div data-id="element-317">
                    <h3 className="text-gray-900 font-bold text-base" data-id="element-318">
                      Comunidad VIP en WhatsApp
                    </h3>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-319">
                  Soporte cercano y respuesta rápida 24/7.
                </p>
              </div>

              <div className="bg-brand-card border border-gray-200 rounded-2xl p-6 text-left shadow-sm" data-id="element-320">
                <div className="flex items-start gap-3 mb-3" data-id="element-321">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-322">
                    <VideoIcon className="w-5 h-5 text-brand-green" data-id="element-323" />
                  </div>
                  <div data-id="element-324">
                    <h3 className="text-gray-900 font-bold text-base" data-id="element-325">
                      Mentorías grupales semanales{' '}
                      <span className="text-brand-green" data-id="element-326">EN VIVO</span>
                    </h3>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-327">
                  Correcciones, estrategia y dudas resueltas en directo.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}